<!-- CUERPO -->
<div class="container-fluid cuerpoPrincipal">
	<app-cli-company-info *ngIf="isDataLoaded" [person]="client"></app-cli-company-info>
	<router-outlet></router-outlet>
</div>

<!-- CUERPO -->

<ul id="tlyPageGuideCLIENTES" data-tourtitle="Home de FACeB2B" class="d-none">

  <!--CLIENTES-->

    <li class="tlypageguide_bottom" data-tourtarget=".tipo_element_to_target">
    <div>
      Desde esta pestaña podrá actuar como ESF o como Cliente sin tener que volver a loguearse.
  </div>
  </li>

  <li class="tlypageguide_top" data-tourtarget=".datos_element_to_target">
    <div>
      Los datos de la entidad son los recogidos de DIRe. Si ha modificado información de su entidad en DIRe puede sincronizar la actualización pulsando  <b class="apunteDescacado">[ <i _ngcontent-c5="" class="fa fa-refresh"></i> ] </b>
    </div>
  </li>

  <li class="tlypageguide_top" data-tourtarget=".noCliente_element_to_target">
		<div>
			<p>Para poder trabajar como Cliente en FACeB2B hay que tener un certificado electrónico válido y haberse dado de alta previamente en DIRe. En FACeB2B como Cliente, puede autorizar a una Empresa de Servicios de Facturación a gestionar las facturas de sus unidades receptoras.</p>
    	<p>La primera vez en FACeB2B tendrá que darse de alta que se firmará con el miniapplet de @firma. <a href="http://firmaelectronica.gob.es/Home/Descargas.html" target="_blank" class="apunteDescacado">Descárguelo aquí</a> </p>
		</div>
	</li>
  <li class="tlypageguide_top pestana" data-tourtarget=".autorizaciones_element_to_target">
    <div>
      <p>Para poder trabajar con FACeB2B tiene que seleccionar una Empresa de Servicios de Facturación (ESF) y autorizarle a que gestione las facturas que lleguen a su unidad receptora.</p>
      <p> Para crear una nueva autorización los pasos son los siguientes:</p>
      <ol>
        <li>Seleccionar la ESF con la que quiere trabajar.</li>
        <li>Seleccionar, de entre sus unidades, la que quiere que sea unidad receptora.</li>
        <li>Generar la autorización.</li>
      </ol>
     <p>La ESF tendrá que aprobar dicha autorización para que su unidad pueda empezar a recibir facturas.</p>
    </div>
  </li>
    <li class="tlypageguide_top pestana" data-tourtarget=".receptores_element_to_target">
      <div>
        <p>En esta pestaña se pueden ver y gestionar las unidades que están recibiendo facturas. La relación de la unidad con la ESF se puede cancelar pulsando el botón <b class="apunteDescacado">[ <i class="fa fa-ban"></i> Desactivar ]</b>.</p>
      <p>La relación se podrá reactivar pulsando el botón <b class="apunteDescacado">[ <i _ngcontent-c24="" class="fa fa-lightbulb-o"></i> Activar ]</b> o puede crear una nueva autorización para que otra ESF gestione sus unidades receptoras.</p>
      <p>Para más información <a href="https://administracionelectronica.gob.es/ctt/faceb2b/descargas#.W6jbyXsza00" target="_blank" class="apunteDestacado" title="Pulse aquí para obtener más información sobre la gestion de las unidades">Pulse aquí para obtener más información sobre la gestion de las unidades</a></p>
      </div>
  </li>
</ul>




<div class="tlyPageGuideWelcome">
    <p><img src="assets/images/logoB2B-white.png" alt="logo FACeB2B"></p>
    <p>Bienvenido a FACeB2B ¿quieres conocer más acerca de esta plataforma?</p>
    <p><button class="tlypageguide_start">Ver Tutorial</button> <button class="tlypageguide_dismiss negativo">Omitir tutorial</button></p>
		<hr />
    <p class="notaPie">Para volver a acceder a este resumen puede hacerlo pulsaldo <b>Guía de uso</b> en el menu del pie de página</p>
</div>



// WEBPACK FOOTER //
// ./src/app/app-manager/client/client.component.html